import { UPLOAD_ATTACHMENT, UPLOAD_ATTACHMENT_SUCCESS, UPLOAD_ATTACHMENT_ERROR, UPLOAD_ATTACHMENT_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UploadAttachment = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_ATTACHMENT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_ATTACHMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_ATTACHMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case UPLOAD_ATTACHMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UploadAttachment;
